<template>
  <div>
    <div class="row">
      <div class="col-lg-8 col-md-7">
        <edit-profile-form @isLoading="isLoading" @showNotification="notifyVue">
        </edit-profile-form>
      </div>
      <div class="col-lg-4 col-md-5">
        <user-card @isLoading="isLoading" @showNotification="notifyVue">
        </user-card>
      </div>
    </div>
  </div>
</template>
<script>
import EditProfileForm from "./EditProfileForm.vue";
import UserCard from "./UserCard.vue";
import mixinMasters from "src/util/mixinMasters";

export default {
  components: {
    EditProfileForm,
    UserCard
  },
  mixins: [mixinMasters],
  methods: {
    isLoading(isShow) {
      this.$emit("cotentLoading", isShow);
    },

    notifyVue(data) {
      this.$emit("showNotification", data);
    }
  },
  created() {
    this.showHideLoading();
  },
  mounted() {
    this.showHideLoading();
  }
};
</script>
<style></style>
